import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setEncryptedDesignIdReducer = (state: DesignState, action: PayloadAction<string | undefined>) => {
  state.encryptedDesignId = action.payload;
};

export default setEncryptedDesignIdReducer;
